const blocks = [
  {
    icon: "ri-home-gear-line",
    image: "https://public.readdy.ai/ai/img_res/b45adde1ab28af35aaef9825b6ad0104.jpg",
    title: "Home Backup Power",
    desc: "Protect your home and family with dependable backup power solutions designed for outages, grid instability, and everyday energy independence. Keep your lights, fridge, router, and essential appliances running — silently and safely — no matter what the grid does.",
    link: "https://ironhavensupply.com/collections/home-backup-power",
    cta: "Shop Home Backup",
    accent: "text-amber-500",
    border: "border-amber-200",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-sun-line",
    image: "https://readdy.ai/api/search-image?query=rural%20homestead%20with%20solar%20panels%20on%20rooftop%20open%20field%20clear%20blue%20sky%20green%20grass%20peaceful%20countryside%20off-grid%20living%20American%20property%20wide%20angle%20golden%20hour%20photography&width=600&height=400&seq=fb002&orientation=landscape",
    title: "Off-Grid Living",
    desc: "Go further from the grid without sacrificing comfort. Our off-grid power systems, solar generators, and storage solutions are built for rural properties, remote land, and total energy freedom — whether you're building a homestead or reducing your utility dependence.",
    link: "https://ironhavensupply.com/collections/off-grid-power-systems",
    cta: "Explore Off-Grid Systems",
    accent: "text-emerald-600",
    border: "border-emerald-200",
    bg: "bg-emerald-50",
  },
  {
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=organized%20emergency%20preparedness%20kit%20backup%20power%20station%20flashlights%20water%20storage%20family%20garage%20clean%20organized%20shelving%20warm%20lighting%20realistic%20photo&width=600&height=400&seq=fb003&orientation=landscape",
    title: "Emergency Preparedness",
    desc: "Be ready before the next storm, outage, or disruption. Iron Haven Supply helps families build practical, reliable emergency power systems that work when it counts — so you never find yourself scrambling in the dark when it matters most.",
    link: "https://ironhavensupply.com/collections/preparedness-systems",
    cta: "Build Your Prep System",
    accent: "text-red-500",
    border: "border-red-200",
    bg: "bg-red-50",
  },
];

export default function FeatureBlocks() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Built for Every Stage of{" "}
            <span className="text-amber-500">Energy Independence</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto text-base leading-relaxed">
            Whether you&apos;re protecting your family from outages, going off-grid, or building a serious preparedness plan — we have the right system for your situation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blocks.map((b) => (
            <div
              key={b.title}
              className={`rounded-lg border ${b.border} overflow-hidden transition-all group`}
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className={`${b.bg} p-6`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/70">
                    <i className={`${b.icon} ${b.accent} text-xl`}></i>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">{b.title}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">{b.desc}</p>
                <a
                  href={b.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`inline-flex items-center gap-2 font-semibold text-sm ${b.accent} hover:underline cursor-pointer whitespace-nowrap`}
                >
                  {b.cta}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
